import { getFilter } from '$c3local/filter.js';

export function initPlayers() {
    const form = $('.players-list-search');
    const input = $('#player-search');
    const container = input.parents('.players-list');
    const noResults = container.find('.players-list-no-results');
    const filterPlayers = getFilter(
        container,
        tab => {
            const items = tab.find('.player-item');
            const category = tab.data('category');
            return [$(`.tab-header[data-category="${category}"]`), category, items];
        },
        (el, visible) => {
            el.parent().parent().toggleClass('players-list-hidden', !visible);
        },
        (noMatches) => {
            noResults.toggle(noMatches);
        }
    );

    form.submit(function (e) {
        e.preventDefault();
        const search = input.val().toLowerCase();
        if (search === '') {
            filterPlayers(() => true);
            return;
        }

        filterPlayers(player => {
            const title = player.find('.player-item-name').text().toLowerCase();
            return title.includes(search);
        });
    });

    $('.players-list-show-all').click(function () {
        input.val('');
        form.trigger('submit');
    });
}